import React, { useState, useEffect } from 'react'
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

export default function PhpackagingmaterialListByProductForm({productFormId} ) {
  const [packagingMaterialList, setPackagingMaterialList] = useState([]);
  const { phpackagingmaterialList } = useSelector((state) => state.pharmaslice);

  useEffect(() => {
    console.log("productFormId=>", productFormId);
    if (phpackagingmaterialList && productFormId !== undefined) {
      setPackagingMaterialList(
        phpackagingmaterialList.filter(item => item.formid === productFormId)
      );
    }
  }, [phpackagingmaterialList, productFormId]);

  return (
    <Grid container direction="row" sx={{ width:'100%', justifyContent: "flex-start", alignItems: "flex-start", }}>
      {packagingMaterialList && packagingMaterialList.map(obj => (
        <Grid item lg={3} sx={{ width: '100%', padding:1}} key={obj.id}>
          <Typography variant="h6" sx={{ backgroundColor:'secondary.100', padding:1, borderRadius: 1, width: '100%', textAlign: 'center', whiteSpace: 'nowrap' }}>
            {obj.title}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}